var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_80_207)" } }, [
        _c("path", {
          attrs: {
            d: "M9.20322 6.7375L1.21885 14.7188C0.925098 15.0125 0.925098 15.4875 1.21885 15.7781C1.5126 16.0688 1.9876 16.0719 2.27822 15.7781L4.05947 13.9969H6.18447C7.7376 13.9969 9.24385 13.5469 10.5282 12.7156C10.8751 12.4906 10.7001 11.9969 10.2845 11.9969C10.1251 11.9969 9.99697 11.8688 9.99697 11.7094C9.99697 11.5813 10.0813 11.4719 10.2001 11.4344L12.7313 10.675C12.8095 10.65 12.8813 10.6094 12.9407 10.55L13.6407 9.85C13.9563 9.53438 13.7313 8.99688 13.2876 8.99688H12.2813C12.122 8.99688 11.9938 8.86875 11.9938 8.70938C11.9938 8.58125 12.0782 8.47188 12.197 8.43438L15.697 7.38438C15.822 7.34688 15.9282 7.2625 15.9876 7.14375C16.3251 6.4875 16.5001 5.75313 16.5001 5C16.5001 3.71875 15.9907 2.49063 15.0845 1.58438L14.9126 1.4125C14.0095 0.509375 12.7813 0 11.5001 0C10.2188 0 8.99072 0.509375 8.08447 1.41563L4.84385 4.65625C3.34385 6.15625 2.5001 8.19063 2.5001 10.3125V12.0406L8.4251 6.11875C8.61885 5.925 8.9376 5.925 9.13135 6.11875C9.3001 6.2875 9.32197 6.54375 9.2001 6.7375H9.20322Z",
            fill: "white",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_80_207" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0.5)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }